module.exports = __webpack_public_path__ + "img/img_kv_bg3.157ed0f0.jpg";